import { render, staticRenderFns } from "./MediaDeniedPage.vue?vue&type=template&id=070e1435&scoped=true"
import script from "./MediaDeniedPage.vue?vue&type=script&lang=js"
export * from "./MediaDeniedPage.vue?vue&type=script&lang=js"
import style0 from "./MediaDeniedPage.vue?vue&type=style&index=0&id=070e1435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e1435",
  null
  
)

export default component.exports